import { API } from "."
import {
  ReadAiReportListResponse,
  ReadAiReportDetailParams,
  ReadAiReportDetailResponse,
} from "@/types/aiReport"

/* AI 리포트 목록 조회 */
export async function readAiReportList() {
  return await API.get<ReadAiReportListResponse>(`/reports/ai`)
}

/* AI 리포트 상세 조회 */
export async function readAiReportDetail({ idfReport }: ReadAiReportDetailParams) {
  return await API.get<ReadAiReportDetailResponse>(`/reports/ai/${idfReport}`)
}

/* AI 리포트 사용자 프롬프트 생성 */
export async function generateAiUserPromptReport(payload: {
  userPrompt: string
  csvData: string
  title: string
}) {
  return await API.post(`/reports/ai/user-prompt`, payload)
}
